import React from "react";
import { Formik, Form, Field, FieldArray } from "formik";
import * as Yup from "yup";
import {
  Button,
  Badge,
  CloseButton,
  InputGroup,
  Row,
  Col,
  Card,
} from "react-bootstrap";
import { useLoader } from "../../../../context/LoaderCotext";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { createTaskNumber } from "../../../../services/TaskNumberService";

const validationSchema = Yup.object().shape({
  fullName: Yup.string().required("Name is required"),
  employeeId: Yup.string().required("Employee ID is required"),
  taskNumbers: Yup.array().of(Yup.string()).min(1, "At least one task number is required"),
});

const AddTaskNumber = () => {
  const navigate = useNavigate();
  const { showLoader, hideLoader } = useLoader();
  const initialValues = {
    fullName: "",
    employeeId: "",
    taskNumbers: [],
    currentTaskNumber: "",
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    const formData = {
      fullName: values.fullName,
      employeeId: values.employeeId,
      taskNumbers: values.taskNumbers,
    };

    if (formData.taskNumbers.length === 0 && values.currentTaskNumber.trim() !== "") {
      formData.taskNumbers.push(values.currentTaskNumber.trim());
    }
    showLoader();
    try {
      await createTaskNumber(formData);
      toast.success("Task number added successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000, // Closes after 3 seconds
      });
      // Delay navigation to ensure toast is visible
      setTimeout(() => {
        navigate("/settings/task-number");
      }, 3000);
      console.log("Task number added successfully");
      // Optionally, redirect or update state after successful add
    } catch (error) {
      console.error("Error adding task number:", error);
      toast.error("Failed to Update Task Number!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
      });
    }
    finally {
      hideLoader();
      
    }
  };

  return (
    <div>
      <Card>
        <h2>Add Task Number</h2>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, errors, touched, setFieldValue }) => (
            <Form>
              <Row>
                <Col>
                  <div controlId="fullName" className="form-group">
                    <label htmlFor="fullName">Name</label>
                    <Field
                      type="text"
                      name="fullName"
                      placeholder="Enter Employee Name"
                      className={`form-control ${touched.fullName && errors.fullName ? "is-invalid" : ""}`}
                    />
                    {touched.fullName && errors.fullName && <div className="invalid-feedback">{errors.fullName}</div>}
                  </div>
                </Col>
                <Col>
                  <div className="form-group" controlId="employeeId">
                    <label htmlFor="employeeId">Employee Id</label>
                    <Field
                      type="text"
                      name="employeeId"
                      placeholder="Enter Employee Id"
                      className={`form-control ${touched.employeeId && errors.employeeId ? "is-invalid" : ""}`}
                    />
                    {touched.employeeId && errors.employeeId && <div className="invalid-feedback">{errors.employeeId}</div>}
                  </div>
                </Col>
                <Col>
                  <div className="form-group" controlId="taskNumbers">
                    <label htmlFor="taskNumbers">Task Numbers</label>
                    <InputGroup className="mb-3">
                      <Field
                        type="text"
                        name="currentTaskNumber"
                        placeholder="Enter Task Number"
                        className="form-control"
                      />
                      <Button
                        variant="outline-secondary"
                        onClick={() => {
                          if (values.currentTaskNumber.trim() !== "") {
                            setFieldValue("taskNumbers", [...values.taskNumbers, values.currentTaskNumber.trim()]);
                            setFieldValue("currentTaskNumber", "");
                          }
                        }}
                      >
                        Add
                      </Button>
                    </InputGroup>
                    <FieldArray name="taskNumbers">
                      {({ remove }) => (
                        <div>
                          {values.taskNumbers.map((taskNumber, index) => (
                            <Badge key={index} pill bg="secondary" className="me-2">
                              {taskNumber}{" "}
                              <CloseButton
                                onClick={() => remove(index)}
                              />
                            </Badge>
                          ))}
                        </div>
                      )}
                    </FieldArray>
                    {touched.taskNumbers && errors.taskNumbers && <div className="text-danger">{errors.taskNumbers}</div>}
                  </div>
                </Col>
              </Row>
              <div className="d-flex justify-content-end">
                <Button variant="primary" type="submit">
                  Add Task Number
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </Card>
      {/* Toast Notification Container */}
      <ToastContainer />
    </div>
  );
};

export default AddTaskNumber;